import { Page } from '@/core/architecture'

import { ConsoleLotteryManagementsTemplate } from './template'
import { useViewModel } from './viewModel'

/**
 * ConsoleLotteryManagements Page
 * Implemented as a practical sample.
 */
export const ConsoleLotteryManagements: Page = () => {
  const { state, actions } = useViewModel()

  return <ConsoleLotteryManagementsTemplate state={state} {...actions} />
}
